var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_1312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31607 20.2117C9.43927 20.0885 9.60866 20.0167 9.78833 20.0167H26.081C26.3787 20.0167 26.5276 20.376 26.3171 20.5864L23.0986 23.8049C22.9754 23.9281 22.806 24 22.6263 24H6.33371C6.03599 24 5.88713 23.6407 6.09759 23.4302L9.31607 20.2117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31607 8.19506C9.4444 8.07186 9.6138 8 9.78833 8H26.081C26.3787 8 26.5276 8.35932 26.3171 8.56978L23.0986 11.7883C22.9754 11.9115 22.806 11.9833 22.6263 11.9833H6.33371C6.03599 11.9833 5.88713 11.624 6.09759 11.4135L9.31607 8.19506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0986 14.1649C22.9754 14.0417 22.806 13.9698 22.6263 13.9698H6.33371C6.03599 13.9698 5.88713 14.3291 6.09759 14.5396L9.31607 17.7581C9.43927 17.8813 9.60866 17.9531 9.78833 17.9531H26.081C26.3787 17.9531 26.5276 17.5938 26.3171 17.3834L23.0986 14.1649Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_1312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 16,
    fill: "white",
    transform: "translate(6 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.101b4c3f1aa544f0363a966e8b1cfa22.svg";
export { ForwardRef as ReactComponent };